import Vue from "vue";
import Vuex from "vuex";

import constants from "./modules/constants";
import config from "./modules/config";
import locale from "./modules/locale";
import auth from "./modules/auth";
import error from "./modules/error";
import search from "./modules/search";
import notifications from "./modules/notifications";
import refreshes from "./modules/refreshes";
import socket from "./modules/socket";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    constants,
    config,
    locale,
    auth,
    error,
    search,
    notifications,
    refreshes,
    socket
  }
});
